import { useAppDispatch } from '@common/hooks/store';
import { authApi } from '@features/auth/api/authApi';
import { freespinApi } from '@features/freespin/api/freespinApi';
import { useCallback } from 'react';

export default function useRefreshAfterGrant() {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(authApi.endpoints.checkToken.initiate(undefined, { subscribe: false, forceRefetch: true }));
    dispatch(freespinApi.endpoints.getUserBonusCards.initiate(undefined, { subscribe: false, forceRefetch: true }));
  }, [ dispatch ]);
}
